<template>
	<div class="btn-group">
		<button
			type="button"
			class="btn btn-sm"
			:class="value == 'table' ? 'btn-primary' : 'btn-default'"
			@click="setModel('table')"
		>
			<i class="fa fa-align-justify"></i>
		</button>
		<button
			type="button"
			class="btn btn-sm"
			:class="value == 'indent' ? 'btn-primary' : 'btn-default'"
			@click="setModel('indent')"
		>
			<i class="fa fa-indent"></i>
		</button>
	</div>
</template>
<script>
	import localforage from 'localforage';
	export default {
		props: ['value'],
		methods: {
			setModel(mode) {
				localforage.setItem('VIEW-MODE-PROPOSTA', mode).then((e) => {
					this.$emit('input', mode);
				});
			},
		},
		mounted() {
			localforage.getItem('VIEW-MODE-PROPOSTA').then((resp) => {
				if (resp != null) {
					this.$emit('input', resp);
				}
			});
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/order-of-service/components/BotanParaTrocarModoDaView.vue